module.exports = __webpack_public_path__ + "media/images/lp_consultation/importance-reason03-0693dd10a8aeeb5e7201309e5852ca3a.png";